<template>
  <div class="home">
    <section class="hero is-small is-dark mb-6">
      <div class="hero-body has-text-centered">
        <p class="title mb-6">Bienvenido!</p>
        <p class="subtitle">
          La mejor gestión de Cafeterías, restaurantes y bares
        </p>
      </div>
    </section>

    <div class="columns is-multiline">
      <div class="column is-12">
        <h2 class="is-size-2 has-text-centered">Mis Cafeterías</h2>
      </div>
      <div class="column is-3" v-for="shop in shops" v-bind:key="shop.id">
        <div class="box has-text-centered">
          <p class="is-size-4">{{ shop.name }}</p>
          <router-link v-bind:to="shop.get_absolute_url" class="button mt-4">
            <span class="material-symbols-rounded"> coffee</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ShopsView",
  data() {
    return {
      shops: [],
    };
  },
  components: {},
  mounted() {
    this.getShops();
    document.title = "Mis Tiendas || Coffee Shop Admin";
  },
  methods: {
    getShops() {
      axios
        .get("/api/v1/shops/")
        .then((response) => {
          this.shops = response.data;
          if (this.shops.length == 1) {
            this.$router.push(`${this.shops[0].get_absolute_url}`);
          }
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.log("Error Autenticación");
            axios.defaults.headers.common["Authorization"] = "";
            this.$store.commit("removeToken");
            this.$router.push("/log-in");
          }
        });
    },
  },
};
</script>
